export default "__VITE_ASSET__CaiTEoPD__"